import moment from "moment";
import axios from "../../../axios/defaultAxios";
import { endpoints } from "../../../axios/endpoints";
import { ExecutionStatuses } from "../../../constants/execution-statuses";

export const getStats = async (type, params, dateRange, statsRef) => {
  const hasTaskType = type !== "All" ? `&task_type=${type}` : "";
  const paramsString = params.name ? `&organization=${params.name}` : `&user_id=${params.id}`;

  const execRes = await axios.get(
    `${endpoints[statsRef]}?from=${dateRange[0]}&to=${dateRange[1]}${hasTaskType}${paramsString}`
  );

  return execRes.data.data;
};

export const processExecutions = (execs) => {
  const executions = execs.ByExecutionType.reduce((result, value, key) => {
    result[value.ID] = value;
    return result;
  }, {});

  const resources = execs.ByResource.reduce((result, value, key) => {
    result[value.ID] = value;
    return result;
  }, {});

  const execsStatus = execs.ByStatus.reduce(
    (result, value, key) => {
      if (value.ID.status === String(ExecutionStatuses.SUCCEEDED)) {
        result.success = {
          ...value,
          Count: result.success.Count + value.Count,
        };
      }
      if (value.ID.status === String(ExecutionStatuses.FAILED)) {
        result.fail = { ...value, Count: result.fail.Count + value.Count };
      }
      if (value.ID.status === String(ExecutionStatuses.IN_PROGRESS)) {
        if (value.ID.resources === "gpu") {
          result.inprogress.gpu = { ...value, Count: value.Count };
        } else if (value.ID.resources === "cpu") {
          result.inprogress.cpu = { ...value, Count: value.Count };
        }
      }
      return result;
    },
    {
      success: {
        Count: 0,
      },
      fail: {
        Count: 0,
      },
      inprogress: {
        gpu: {
          Count: 0,
        },
        cpu: {
          Count: 0,
        },
      },
    }
  );
  execsStatus.total = execs.TotalCount;
  return {
    executions,
    resources,
    execsStatus,
  };
};

export const DEFAULT_DATE_RANGE = ["1999-01-01", moment(Date.now()).format("YYYY-MM-DD")];
